const STORAGE_KEY = "notificationToastsShown";

function readStoredIds() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed.map(String) : []);
  } catch {
    return new Set();
  }
}

function writeStoredIds(ids) {
  try {
    const list = Array.from(ids).slice(-300);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    // ignore quota / private mode errors
  }
}

const shownToastIds = readStoredIds();

export function hasShownNotificationToast(notificationId) {
  if (!notificationId) return false;
  return shownToastIds.has(String(notificationId));
}

export function markNotificationToastShown(notificationId) {
  if (!notificationId) return;
  const id = String(notificationId);
  shownToastIds.add(id);
  writeStoredIds(shownToastIds);
}
